import classnames from 'classnames';
import { Select } from 'antd';

import { BaseFormFieldWrapper } from '../BaseFormFieldWrapper/BaseFormFieldWrapper';
import { BaseIcon } from '..';

import './BaseSelect.scss';

const { Option } = Select;

const BaseSelect_ = (props) => {
  const { field, selectOptions, customKeys, onBlur, handleChange, placeholder, valueType, mode, ...rest } = props;

  return (
    <Select
      className={classnames({ 'multiple-select': mode === 'multiple' })}
      showSearch
      // https://ant.design/components/select/ - check documentation for option.props.children origin.
      filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
      {...field}
      {...rest}
      onBlur={onBlur}
      onChange={(e) => handleChange(e)}
      placeholder={placeholder}
      suffixIcon={<BaseIcon icon="arrow-down" />}
      mode={mode || 'default'}
      placement="bottomLeft"
      styles={{
        popup: {
          root: {
            maxWidth: '560px', // Prevent dropdown from being too wide
          },
        },
      }}
      getPopupContainer={(triggerNode) => triggerNode.parentNode}
      popupMatchSelectWidth={false} // Allow dropdown to be wider than select
    >
      {selectOptions.map((option) => (
        <Option
          key={customKeys ? option[customKeys.value] : option.value}
          value={customKeys ? option[customKeys.value] : option.value}
        >
          {customKeys ? option[customKeys.label] : option.label}
        </Option>
      ))}
    </Select>
  );
};

export const BaseSelect = BaseFormFieldWrapper(BaseSelect_);
export default BaseSelect;
